import isElement from "lodash.iselement";
import fetchProductData from "../api/fetchProductData.js";
import Quantity from "./quantity.js";
import {
  updateTextContent,
  updateAttrs,
  updateDataset,
  updateValue,
  mapActiveClass
} from "../helpers/dom.js";

class Product {
  constructor(base, { onOpen = () => {} } = {}) {
    if (!isElement(base)) return;
    this.base = base;
    this._init();
    this._callbacks = { onOpen };
  }
  getState() {
    return {
      size: this._size,
      quantity: this._quantity.value
    };
  }
  setSize(value) {
    fetchProductData(this.id, value, this._update.bind(this));
    this._size = value;
    this._highlightActiveSize();
    updateValue(this.base, "input[name^='options[size']", value);
  }
  setQuantity(value) {
    if (this._quantity) {
      this._quantity.setValue(value);
    }
  }
  buy() {
    if (isElement(this._buyButton)) {
      this._buyButton.click();
    }
  }
  _init() {
    // Set product id
    const id = parseInt(this.base.dataset.id);
    if (!Number.isInteger(id)) return;
    this.id = id;
    // Add event listener to open full card
    this.base
      .querySelector(".product__link")
      .addEventListener("click", this._onLinkClick.bind(this));
    // Init quantity widget
    const quantityElement = this.base.querySelector(".quantity");
    const availableElement = this.base.querySelector(".available[data-value]");
    if (quantityElement && availableElement) {
      this._quantity = new Quantity({
        base: quantityElement,
        limit: availableElement.dataset.value
      });
    }
    // Init sizes widget
    const sizeButtons = [...this.base.querySelectorAll(".sizes__size")];
    if (sizeButtons.length > 0) {
      const activeButton = sizeButtons.find(btn => btn.classList.contains("size__size--active"));
      if (isElement(activeButton)) {
        this._size = activeButton.dataset.value;
      } else {
        this._size = sizeButtons[0].dataset.value;
      }
      this._highlightActiveSize();
      sizeButtons.forEach(button =>
        button.addEventListener("click", this._onSizeClick.bind(this))
      );
    }
    // Get buy button
    this._buyButton = this.base.querySelector(".buy");
  }
  _highlightActiveSize() {
    if (typeof this._size === "undefined") return;
    mapActiveClass(
      this.base.querySelectorAll(".sizes__size"),
      "sizes__size--active",
      element => element.dataset.value === this._size
    );
  }
  _onLinkClick(e) {
    e.preventDefault();
    this._callbacks.onOpen(this);
  }
  _onSizeClick(e) {
    e.preventDefault();
    const size = e.target.dataset.value;
    if (size) {
      this.setSize(size);
    }
  }
  _update(data) {
    this.id = data.id;
    updateDataset(this.base, this.base, { id: data.id });
    // Set title
    updateTextContent(this.base, ".product__title", data.pagetitle);
    // Set href
    updateAttrs(this.base, "a.product__link", { href: `#product_${data.id}` });
    // Set image
    updateAttrs(this.base, "img.product__image", { src: data.photo1 });
    // Set product code
    updateTextContent(this.base, ".product__code", `Код: ${data.code}`);
    // Set price
    updateDataset(this.base, ".price", { value: data.price });
    updateTextContent(this.base, ".price__real", `${data.price} ₽`);
    updateTextContent(
      this.base,
      ".price__old",
      data.old_price ? `${data.old_price} ₽` : ""
    );
    // Set available
    updateDataset(this.base, ".available", { value: data.quantity });
    updateTextContent(
      this.base,
      ".available",
      `Доступно - ${data.quantity} шт.`
    );
    // Set hidden input value
    updateValue(this.base, "input[name=id]", data.id);
    // Update quantity widget limit
    if (this._quantity) {
      this._quantity.updateLimit(data.quantity);
    }
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/js/components/product.js